import './instrument.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Remove any existing title elements to prevent duplicates
document.getElementsByTagName('title')[0]?.remove()

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
